<template>
  <div class="widget" v-bind:class="[{'loaded':loaded},className]" v-if="$aclInterfaceValidator('weeboxshop.order.statsca')">

    <header class="widget-header">
      <h2 class="widget-title">{{ title }}</h2>
      <h3 class="widget-title-period">
        <span v-for="item in periods" v-if="item.id == period">{{ item.label }}</span>
      </h3>

      <div class="widget-actions-container">
        <!--
        <div><form-toggle label="" v-model="is_ttc" label-true="TTC" label-false="HT"></form-toggle></div>
        -->
        <widget-dropdown v-model="period" :options="periods" :callback="filterByPeriod"></widget-dropdown>
      </div>

      <div class="form-advanced-filter" v-if="showAdvancedFilterVue">
        <span>Filtrer par date</span>
        <div class="date-filters">
          <form-datex label="du" v-model="dateFilter.start_at" :hide-time="true" time="00:00:00"></form-datex>
          <form-datex label="au" v-model="dateFilter.end_at" :hide-time="true" time="23:59:59"></form-datex>
        </div>
      </div>


    </header>

    <div class="widget-preloader">
      <div class="pre-loader">
        <div class="box1"></div>
        <div class="box2"></div>
        <div class="box3"></div>
        <div class="box4"></div>
        <div class="box5"></div>
      </div>
    </div>

    <div class="widget-content" v-if="stats.dataset">
      <!--
      <div class="widget-content-datas">
        <div class="data-labels">


        </div>
      </div>
      -->

      <div class="widget-chart" v-bind:class="{'active':stats.labels.length}" style="max-width: 80%;margin: auto;padding-top: 20px;">
        <chart :dataset="stats.dataset" :labels="stats.labels" :options="options" v-if="stats"></chart>
      </div>
    </div>
  </div>
</template>
<script>

    import InvoiceService from './InvoiceService.js';
    import Pie from '../../../components/chart/Pie.vue';

    export default {
      name: 'Widget',
      components: {
        'chart' : Pie
      },
      props: ['title','period','className','branch'],
      data () {
        return {
          periods: [
            {id: 'last_7days', label: '7 derniers jours'},
            {id: 'current_month', label: 'Ce mois'},
            {id: 'last_month', label: 'Le mois dernier'},
            {id: 'since_1_month', label: '30 derniers jours'},
            {id: 'since_3_months', label: '90 derniers jours'},
            {id: 'current_year', label: 'Cette année'},
            {id: 'last_year', label: 'Depuis 12 mois'},
            {id: 'all', label: 'Tout'},
            {id: 'custom', label: 'Personnalisé'},
          ],
          forceRefresh: null,
          loaded: false,
          stats: {
            dataset: null,
            labels: null
          },
          dateFilter: {
            start_at: '',
            end_at: '',
          },
          showAdvancedFilterVue: false,
          count: null,
          total: null,
          currency: null,
          is_ttc: true,
          options: {
            layout: {
              padding: {
                left: 0,
                right: 10,
                top: 0,
                bottom: 0
              }
            },
            legend: {
              position: 'left',
              reverse: true
            },
            plugins: {
              datalabels: [
                {
                  //render: 'value', // percentage
                  fontSize: 13,
                  color: '#fff',
                  fontStyle: 'bold',
                  precision: 0,
                  //position: 'outside'
                  render: function (args) {
                    // args will be something like:
                    // { label: 'Label', value: 123, percentage: 50, index: 0, dataset: {...} }
                    return args.value + " (" + args.percentage + "%)";
                  }
                }
              ],
            },
            tooltips: {
              callbacks: {
                label: function(tooltipItems, data) {
                  return data.labels[tooltipItems.index] + ' (' + data.datasets[tooltipItems.datasetIndex].label + ') : ' + data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index];
                }
              }
            }
          }
        }
      },
      mounted: function(){
        this.currency = this.$store.state.scope.currency_id
        this.is_ttc = this.$store.state.scope.is_ttc
        this.period = this.period ? this.period : this.periods[0].id

        if(this.period == 'custom') {
          this.showAdvancedFilterVue = true
        }else{
          this.showAdvancedFilterVue = false;
        }

        this.filterByPeriod(this.period);

      },
      watch: {
        'dateFilter.start_at'(newVal, oldVal) {
          if(newVal != '' && this.dateFilter.end_at != ''){
            this.filterByPeriodAndByDate(this.period, this.dateFilter);
          }
        },
        'dateFilter.end_at'(newVal, oldVal) {
          if(newVal != '' && this.dateFilter.start_at != ''){
            this.filterByPeriodAndByDate(this.period, this.dateFilter);
          }
        }
      },
      methods: {
        filterByPeriod: function(period)
        {

          if(period == 'custom') {
            this.showAdvancedFilterVue = true
          }else{
            this.showAdvancedFilterVue = false;
          }

          if(period != 'custom') {

            this.loaded = false;
            this.period = period



            InvoiceService.getStatsByCustomers( this.period, this.branch).then((response) => {
              this.stats.dataset = response.data.result.stats.dataset
              this.stats.labels = response.data.result.stats.labels

              this.total = response.data.result.total
              this.total_compare= response.data.result.total_compare

              this.loaded = true;
            }).catch((response) => {
              console.log("error", response);
              this.loaded = true;
            })

          }
        },
        filterByPeriodAndByDate: function(period, dateFilter)
        {
          this.loaded = false;

          this.period = period
          this.date = JSON.stringify(dateFilter);

          InvoiceService.getStatsByCustomers( this.period, this.branch, this.date ).then((response) => {
            this.stats.dataset = response.data.result.stats.dataset
            this.stats.labels = response.data.result.stats.labels

            this.total = response.data.result.total
            this.total_compare= response.data.result.total_compare

            this.loaded = true;
          }).catch((response) => {
            console.log("error", response);
            this.loaded = true;
          })
        }
      }
    }
</script>


// WEBPACK FOOTER //
// src/modules/invoicing/invoice/StatsBestCustomers.vue